<template>
  <div>
    <div class="read_center_box" id="read_center_box">
      <p class="dqyd">
        <!-- <img src="@/assets/icon/read_ico_sj.png" />  -->
      </p>
      <div id="box">
        <div
          id="viewer"
          style="padding: 20px; box-sizing: border-box"
          v-show="boxViewer"
        >
          <div class="flipbook" v-if="wsitch">
            <div v-for="value in PdfItems">
              <div class="gradient"></div>
              <img :src="'http://' + value" />
            </div>
          </div>
        </div>
        <!-- 				<div style="position: relative;left: 0; bottom: 0;" id="slider-bar" class="turnjs-slider">
					<div id="slider"></div>
				</div>
				<div class="yema">position
					{{PdfIndex}}/{{PdfSize}}
				</div> -->
      </div>
    </div>
    <div class="read_right_box">
      <div class="read_right_box1">
        <el-popover
          placement="left"
          width="350"
          trigger="click"
          v-model="shezhivisible"
        >
          <div class="shezhi">
            <i class="el-icon-error" @click="shezhivisible = false"></i>
            <li>
              <p>阅读主题</p>
              <div class="xz_box ydzt">
                <span
                  v-for="(item, index) in backgroundList"
                  :key="index"
                  :class="item.backclass === backclass ? 'active' : ''"
                  :style="'background: ' + item.color"
                  @click="changezt(item), result(), shezhisave()"
                ></span>
              </div>
            </li>
          </div>
          <li slot="reference">
            <img
              v-if="backclass !== 'zt_heise'"
              src="@/assets/icon/read_ico_shezhi.png"
            />
            <img
              v-if="backclass === 'zt_heise'"
              src="@/assets/icon/read_ico_shezhi_bai.png"
            />
            <p>设置</p>
          </li>
        </el-popover>
        <!-- <li
          :class="
            this.$route.query.typeName == 0 && isBookshelf === true
              ? 'cursorDefault'
              : ''
          "
          @click="addBookshelf()"
        >
          <img
            v-if="backclass !== 'zt_heise'"
            src="@/assets/icon/read_ico_shujia.png"
          />
          <img
            v-if="backclass === 'zt_heise'"
            src="@/assets/icon/read_ico_shujia_bai.png"
          />
          <p v-if="isBookshelf">已加书架</p>
          <p v-if="!isBookshelf">加入书架</p>
        </li> -->
        <li @click="fullScreen">
          <img
            v-if="backclass !== 'zt_heise'"
            src="@/assets/icon/read_ico_quanping.png"
          />
          <img
            v-if="backclass === 'zt_heise'"
            src="@/assets/icon/read_ico_shujia_bai.png"
          />
          <p>全屏阅读</p>
        </li>
      </div>
      <div class="read_right_box2">
        <div id="prev">
          <img
            @click="previous()"
            :style="PdfIndex === 1 ? 'visibility:hidden' : ''"
            src="@/assets/icon/read_ico_shang.png"
          />
        </div>
        <div id="next">
          <img
            @click="next()"
            :style="PdfIndex === PdfSize ? 'visibility:hidden' : ''"
            src="@/assets/icon/read_ico_xia.png"
          />
        </div>
      </div>
    </div>
    <div class="slider_box" v-if="PdfSize > 1">
      <el-slider
        :min="1"
        v-model="PdfIndex"
        @change="onProgressChange"
        :max="PdfSize"
      >
      </el-slider>
    </div>
  </div>
</template>

<script>
import jqueryui from "/public/js/jquery-ui.js";
import turn from "/public/js/turn.min.js";
import basic from "/public/js/basic.js";
import {
  getConvertImagePath, //获取转换后的图片路径（pdf在线阅读）
} from "@/api/special/special";
// import screenfull from "screenfull";
export default {
  components: {},
  data() {
    return {
      backclass: "zt_moren", //主题的背景颜色class
      shezhivisible: false,
      backgroundList: [
        {
          backclass: "zt_moren",
          color: "#f8f4e9",
        },
        {
          backclass: "zt_niupizhi",
          color: "#dbcfa5",
        },
        {
          backclass: "zt_danlvse",
          color: "#ebf1e5",
        },
        {
          backclass: "zt_danlanse",
          color: "#e9f5f5",
        },
        {
          backclass: "zt_danfense",
          color: "#f4e9e9",
        },
        {
          backclass: "zt_huise",
          color: "#e6e2e2",
        },
        {
          backclass: "zt_heise",
          color: "#424242",
        },
      ],
      PdfItems: [],
      PdfIndex: 1, //当前页数
      PdfSize: 1, //pdf个数
      slider: "",
      loading: false,
      item: undefined,
      index: undefined,
      wsitch: true,
      isBookshelf: false,
      TrialPdfSize: "", //试读
      boxViewer: true,
    };
  },
  props: {
    isTrial: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  methods: {
    tabbook(item, index, filePath) {
      // this.Trial = false; //试读
      this.item = item;
      this.index = index;
      this.loading = this.$loading({
        lock: true,
      });
      this.initbook(item, index, filePath);
      if (localStorage.getItem("shezhisave")) {
        var newshezhi = JSON.parse(localStorage.getItem("shezhisave"));
        this.num = newshezhi.num;
        this.zwzt = newshezhi.zwzt;
        this.backclass = newshezhi.backclass;
        this.$store.state.read.backclass = newshezhi.backclass;
      }
    },
    initbook(item, index, filePath) {
      //获取pdf图片list
      this.wsitch = false;
      setTimeout(() => {
        this.wsitch = true;
        getConvertImagePath({
          filePath: filePath,
        }).then((res) => {
          this.PdfItems = res.data;
          this.PdfSize = res.data.length;
          if (this.isTrial) {
            let num = this.PdfSize * 0.1;
            this.TrialPdfSize = num.toFixed();
            if (this.PdfSize < 10) {
              this.TrialPdfSize = 1;
            }
            this.PdfItems = this.PdfItems.slice(0, this.TrialPdfSize);
            // this.loading.close()
          }
          this.showEpub(""); //加载阅读器，传之前的阅读位置
        });
      }, 100);
    },

    onProgressChange(page) {
      if (Number(this.TrialPdfSize) < page && this.isTrial) {
        this.PdfIndex = Number(this.TrialPdfSize);
        this.$message("该商品试读结束");
        return;
      }
      //翻页方法
      $(".flipbook").turn("page", this.PdfIndex);
      // 容器元素.turn(‘page’, 页码)
    },
    showEpub(readingLocation) {
      var that = this;
      setTimeout(function () {
        setTimeout(function () {
          $(".flipbook").turn({
            width: window.innerWidth - 522,
            height: window.innerHeight - 130,
            elevation: 50,
            // gradients: true,
            autoCenter: true,
            when: {
              turned: function (e, page) {
                that.PdfIndex = page;
              },
            },
          });
        }, 300);
        if (readingLocation > 1) {
          setTimeout(() => {
            $(".flipbook").turn("page", readingLocation);
          }, 600);
        }
        setTimeout(() => {
          let next = document.getElementById("next");
          let keyListener = function (e) {
            // 左键
            if ((e.keyCode || e.which) == 37) {
              $(".flipbook").turn("previous");
            }
            // 上键
            if ((e.keyCode || e.which) == 38) {
              $(".flipbook").turn("previous");
            }
            // 右键
            if ((e.keyCode || e.which) == 39) {
              $(".flipbook").turn("next");
              if (Number(that.TrialPdfSize) == that.PdfIndex && that.isTrial) {
                that.$message("该商品试读结束");
                this.checkIsBuys();
                return;
              }
            }
            // 下键
            if ((e.keyCode || e.which) == 40) {
              $(".flipbook").turn("next");
              if (Number(that.TrialPdfSize) == that.PdfIndex && that.isTrial) {
                that.$message("该商品试读结束");
                this.checkIsBuys();
                return;
              }
            }
          };
          document.addEventListener("keyup", keyListener, false);
        }, 800);

        that.loading.close();
      }, 100);
    },
    //全屏阅读
    fullScreen() {
      this.loading = this.$loading({
        lock: true,
      });
      // screenfull.toggle();
      this.wsitch = false;
      setTimeout(() => {
        this.wsitch = true;
        setTimeout(() => {
          this.tabbook(this.item, this.index);
          this.loading.close();
        }, 100);
      }, 100);
    },
    previous() {
      this.$emit("updateReadStatic");
      $(".flipbook").turn("previous");
    },
    next() {
      this.$emit("updateReadStatic");
      if (Number(this.TrialPdfSize) == this.PdfIndex && this.isTrial) {
        this.$message("该商品试读结束");
        return;
      }
      $(".flipbook").turn("next");
    },
    result() {
      this.changezt({
        backclass: this.backclass,
      });
      var hei = this.backclass === "zt_heise" ? "#ccc" : "#000";
    },
    changezt(item) {
      //更换主题
      this.backclass = item.backclass;
      this.$store.state.read.backclass = item.backclass;
    },
    shezhisave() {
      setTimeout(() => {
        var shezhisave = {
          num: this.num, //字体
          backclass: this.backclass, //主题
          zwzt: this.zwzt, //字体
        };
        localStorage.setItem("shezhisave", JSON.stringify(shezhisave));
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
#extras {
  /*  width: 600px;
margin: 40px auto;*/
  width: 600px;
  height: 100vh;
  /* overflow: auto; */
  margin: 0 auto;
}
#box {
  padding-top: 26px;
}

.read_center_box > iframe {
  background: white;
  box-shadow: 0 0 4px #ccc;

  /*margin: 10px;
padding: 20px;*/
}

#viewer {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-bottom: 20px;
  box-shadow: 0 0 5px #848484;
  overflow: hidden;
  /*  !* overflow: auto; *!
margin: 0 auto;*/
}

#viewer.spreads {
  top: 0;
  margin-top: 50px;
}

[ref="epubjs-mk"] {
  background: url("data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPScxLjEnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycgeG1sbnM6eGxpbms9J2h0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsnIHg9JzBweCcgeT0nMHB4JyB2aWV3Qm94PScwIDAgNzUgNzUnPjxnIGZpbGw9JyNCREJEQkQnIGlkPSdidWJibGUnPjxwYXRoIGNsYXNzPSdzdDAnIGQ9J00zNy41LDkuNEMxOS42LDkuNCw1LDIwLjUsNSwzNC4zYzAsNS45LDIuNywxMS4zLDcuMSwxNS42TDkuNiw2NS42bDE5LTcuM2MyLjgsMC42LDUuOCwwLjksOC45LDAuOSBDNTUuNSw1OS4yLDcwLDQ4LjEsNzAsMzQuM0M3MCwyMC41LDU1LjQsOS40LDM3LjUsOS40eicvPjwvZz48L3N2Zz4=")
    no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 0;
}

.epub_box {
  width: 100%;
  overflow: hidden;
  background: rgb(242, 242, 242);
  padding: 0 20px;
  box-sizing: border-box;
  min-height: 100vh;
}

.epub_box_c {
  width: 100%;
  display: table;
}

.read_left_box {
  width: 304px;
  float: left;
  margin-right: 15px;
}

.read_left {
  width: 100%;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
}

.epub_box .bread {
  width: 100% !important;
}

.read_leftt1 {
  margin-top: 12px;
  margin-bottom: 12px;
}

.read_leftt1_img {
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto;
  box-shadow: 0 0 3px #ccc;
  margin-bottom: 14px;
}

.read_leftt1 > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
}

.read_leftt1 > p span {
  border: 1px solid #0081ce;
  border-radius: 6px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
  line-height: 22px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 10px;
}

.read_leftt2 {
  width: 100%;
  overflow: hidden;
  padding: 0 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 10px;
}

.read_leftt2 li {
  list-style: none;
  width: 100%;
  float: left;
  font-size: 14px;
  margin-bottom: 8px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.read_leftt3 {
  width: 100%;
  float: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.read_left2 {
  width: 100%;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
}

.read_left2 .theme-title::before {
  background: #f6a200;
}

.read_left2_ul {
  width: 100%;
  float: left;
  margin-top: 15px;
}

.read_left2_ul li {
  width: 100%;
  float: left;
  height: 46px;
  border-top: 1px solid #f2f2f2;
  list-style: none;
}

.read_left2_ul li p {
  font-size: 14px;
  float: left;
  width: calc(100% - 30px);
  cursor: pointer;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #333333;
}

.read_left2_ul li span {
  float: right;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
}

.read_left2_ul li span.mf {
  color: #2e9adb;
}

.read_left2_ul li span.ff {
  color: #ff5353;
}

.read_left2_ul li.active p {
  color: #2e9adb;
}

.read_center_box {
  float: left;
  width: calc(100% - 400px);
  min-height: 95vh;
  position: relative;
}

.read_right_box {
  float: right;
  width: 60px;
}

.read_right_box1 {
  width: 100%;
  float: left;
  position: relative;
}

.read_right_box1 li {
  list-style: none;
  width: 100%;
  height: 60px;
  float: left;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}

.read_right_box1 li img {
  display: block;
  margin: 10px auto;
  height: 20px;
}

.read_right_box1 li p {
  font-size: 13px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

.read_right_box2 {
  width: 100%;
  float: left;
  margin-top: 8px;
}

.read_right_box2 img {
  display: block;
  margin: 12px auto;
  cursor: pointer;
}

.mulu {
  width: 100%;
  max-height: calc(100vh - 130px);
  float: left;
  /* padding: 15px 24px; */
  box-sizing: border-box;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
}

.mulu::-webkit-scrollbar {
  width: 5px;
  /*height: 4px;*/
}

.mulu::-webkit-scrollbar-thumb {
  border-radius: 15px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #fbfbfb;
}

.mulu::-webkit-scrollbar-track {
  border-radius: 0;
}

.mulu > i {
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
}

.mulu > li {
  list-style: none;
  width: 100%;
  float: left;
}

.rmulu li {
  cursor: pointer;
}

.mulu > li > p {
  width: 100%;
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 5px;
  padding-bottom: 5px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}

.twomulu {
  margin-left: 10px;
}

.twomulu > li {
  width: 100%;
  list-style: outside;
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 5px;
  padding-bottom: 5px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}

.mulu_liright {
  float: right;
}

.mulu_liright span {
  margin-left: 8px;
  cursor: pointer;
}

.shezhi {
  width: 100%;
  float: left;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}

.shezhi > i {
  position: absolute;
  right: 0px;
  top: -10px;
  cursor: pointer;
}

.shezhi li {
  width: 100%;
  float: left;
  list-style: none;
  margin-bottom: 30px;
}

.shezhi li p {
  float: left;
  font-size: 13px;
  height: 21px;
  line-height: 21px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
}

.xz_box {
  width: calc(100% - 80px);
  margin-left: 15px;
  float: left;
  height: 21px;
}

.shezhi li:last-child {
  margin-bottom: 0;
}

.ydzt span {
  width: 22px;
  height: 22px;
  float: left;
  border: 1px solid #999999;
  border-radius: 50%;
  margin-right: 10px;
  cursor: pointer;
}

.ydzt span.active {
  border: 1px solid red;
}

.ydzt span.active:before {
  content: "√";
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  color: red;
  display: block;
}

.zwzt span {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 21px;
  margin-right: 10px;
  cursor: pointer;
}

.zwzt span.active {
  color: #0081ce;
}

.ztdx .el-input-number {
  margin-top: -4px;
}

.shezhi_button {
  display: table;
  margin: 20px auto 0;
}

.shezhi_button span {
  width: 80px;
  cursor: pointer;
  float: left;
  border: 1px solid #2e9adb;
  text-align: center;
  line-height: 24px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #2e9adb;
  height: 24px;
  background: #fff;
  border-radius: 6px;
  margin-right: 30px;
}

.shezhi_button span:last-child {
  margin-right: 0;
}

.shezhi_button span:first-child {
  background: #2e9adb;
  color: #fff;
}

.color_hei .read_left {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_left2 {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_right_box1 {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_center_box {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_leftt1 > p {
  color: #ccc;
}

.color_hei .read_leftt2 li {
  color: #ccc;
}

.color_hei .read_leftt3 {
  color: #ccc;
}

.color_hei .theme-title {
  color: #ccc;
}

.color_hei .read_left2_ul li p {
  color: #ccc;
}

.color_hei .read_right_box1 li p {
  color: #ccc;
}

.dqyd {
  line-height: 35px;
  margin-left: 20px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.dqyd img {
  float: left;
  width: 12px;
  margin-top: 12px;
  margin-right: 5px;
}

/* 默认 */
.zt_moren {
  background: #e6e1d5;
  position: relative;
}

.zt_moren .read_left {
  background: #f5f1e8;
}

.zt_moren .read_left2 {
  background: #f5f1e8;
}

.zt_moren .read_right_box1 {
  background: #f5f1e8;
}

.zt_moren .read_center_box {
  background: #f5f1e8;
}

.zt_moren .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_moren .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_moren .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 牛皮纸 */
.zt_niupizhi {
  background: #dbcfa5;
}

.zt_niupizhi .read_left {
  background: #efe7c9;
}

.zt_niupizhi .read_left2 {
  background: #efe7c9;
}

.zt_niupizhi .read_right_box1 {
  background: #efe7c9;
}

.zt_niupizhi .read_center_box {
  background: #efe7c9;
}

.zt_niupizhi .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_niupizhi .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_niupizhi .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡绿色 */
.zt_danlvse {
  background: #d2e0d0;
}

.zt_danlvse .read_left {
  background: #e6f0e6;
}

.zt_danlvse .read_left2 {
  background: #e6f0e6;
}

.zt_danlvse .read_right_box1 {
  background: #e6f0e6;
}

.zt_danlvse .read_center_box {
  background: #e6f0e6;
}

.zt_danlvse .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danlvse .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danlvse .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡蓝色 */
.zt_danlanse {
  background: #d2dcdc;
}

.zt_danlanse .read_left {
  background: #e6f0f0;
}

.zt_danlanse .read_left2 {
  background: #e6f0f0;
}

.zt_danlanse .read_right_box1 {
  background: #e6f0f0;
}

.zt_danlanse .read_center_box {
  background: #e6f0f0;
}

.zt_danlanse .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danlanse .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danlanse .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡粉色 */
.zt_danfense {
  background: #e6cfcf;
}

.zt_danfense .read_left {
  background: #f0e5e5;
}

.zt_danfense .read_left2 {
  background: #f0e5e5;
}

.zt_danfense .read_right_box1 {
  background: #f0e5e5;
}

.zt_danfense .read_center_box {
  background: #f0e5e5;
}

.zt_danfense .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danfense .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danfense .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 灰色 */
.zt_huise {
  background: #d4d4d4;
}

.zt_huise .read_left {
  background: #dadada;
}

.zt_huise .read_left2 {
  background: #dadada;
}

.zt_huise .read_right_box1 {
  background: #dadada;
}

.zt_huise .read_center_box {
  background: #dadada;
}

.zt_huise .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_huise .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_huise .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 黑色 */
.zt_heise {
  background: #000;
}

.zt_heise .read_left {
  background: #424242;
}

.zt_heise .read_left2 {
  background: #424242;
}

.zt_heise .read_right_box1 {
  background: #424242;
}

.zt_heise .read_center_box {
  background: #424242;
}

.zt_heise .read_leftt2 {
  border-color: #fff;
}

.zt_heise .read_right_box1 li {
  border-color: #fff;
}

.zt_heise .read_left2_ul li {
  border-color: #fff;
}

.zt_heise .theme-title {
  color: #fff;
}

.zt_heise .read_leftt1 > p {
  color: #fff;
}

.zt_heise .read_leftt2 li {
  color: #fff;
}

.zt_heise .read_leftt3 {
  color: #fff;
}

.zt_heise .read_left2_ul li p {
  color: #fff;
}

.zt_heise .read_right_box1 li p {
  color: #fff;
}

.slider_box {
  position: absolute;
  width: 98%;
  bottom: 0;
  opacity: 0.4;
}

.slider_box:hover {
  opacity: 1;
}

::v-deep .bread {
  width: 100% !important;
}

::v-deep .epub-container::-webkit-scrollbar {
  width: 5px;
  /*height: 4px;*/
}

::v-deep .epub-container::-webkit-scrollbar-thumb {
  border-radius: 15px;
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3); */
  /* background: #fbfbfb; */
  background: rgba(144, 147, 153, 0.3);
}

::v-deep .epub-container::-webkit-scrollbar-thumb:hover {
  background: rgba(144, 147, 153, 0.5);
}

::v-deep .epub-container::-webkit-scrollbar-track {
  border-radius: 0;
}

#flipbook > div {
  background: #fff;
}

.flipbook {
}

/*阅读css*/
.flipbook img {
  width: 100%;
  height: calc(100vh - 129px);
}

.flipbook-viewport {
  width: 100%;
  float: left;
  margin-top: 40px;
  overflow: hidden;
  height: 860px;
  position: relative;
}

.flipbook-viewport .container {
  position: absolute;
  top: 30px;
  left: 50%;
  margin: auto;
  width: 0;
}

.flipbook-viewport .flipbook {
  width: 1090px;
  height: 760px;
  left: -545px;
}

.flipbook-viewport .page {
  width: 461px;
  height: 600px;
  background-color: white;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.flipbook .page {
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  -ms-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.flipbook-viewport .page img {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0;
}

.flipbook-viewport .shadow {
  -webkit-transition: -webkit-box-shadow 0.5s;
  -moz-transition: -moz-box-shadow 0.5s;
  -o-transition: -webkit-box-shadow 0.5s;
  -ms-transition: -ms-box-shadow 0.5s;
  -webkit-box-shadow: 0 0 20px #ccc;
  -moz-box-shadow: 0 0 20px #ccc;
  -o-box-shadow: 0 0 20px #ccc;
  -ms-box-shadow: 0 0 20px #ccc;
  box-shadow: 0 0 20px #ccc;
}

.no-transition {
  -webkit-transition: none;
  -moz-transition: none;
  -o-transition: none;
  -ms-transition: none;
}

.turnjs-slider .thumbnail div {
  width: 100px;
  margin: 7px;
  height: 70px;
  background-color: white;
}

.turnjs-slider .ui-slider {
  position: relative;
  text-align: left;
}

.turnjs-slider .ui-slider-horizontal {
  height: 8px;
  width: 520px;
  margin-left: 39px;
}

.turnjs-slider .ui-slider-handle {
  position: absolute;
  z-index: 0;
  width: 80px;
  height: 8px;
  cursor: default;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  border-radius: 5px;
}

.turnjs-slider .ui-slider-horizontal .ui-slider-handle {
  margin-left: -40px;
  margin-top: -1px;
}

.turnjs-slider .ui-slider-handle {
  border: 1px solid white;
  background-color: black;
  opacity: 0.2;
  display: block;
  -webkit-transition: opacity 0.2s;
  -moz-transition: opacity 0.2s;
  -ms-transition: opacity 0.2s;
  -o-transition: opacity 0.2s;
  transition: opacity 0.2s;
}

.turnjs-slider {
  width: 600px;
  height: 8px;
  background: rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -o-border-radius: 5px;
  -ms-border-radius: 5px;
  border-radius: 5px;
  margin: 20px auto;
}

.no-transition {
  -webkit-transition: none;
  -moz-transition: none;
  -o-transition: none;
  -ms-transition: none;
}

.turnjs-slider .thumbnail {
  width: 115px;
  height: 85px;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  top: -100px;
  left: -17px;
  display: none;
  -webkit-transform: translate3d(0px, 50px, 0px) scale(0.1, 0.1);
  -webkit-transition: all 0.2s;
  -webkit-border-radius: 5px;
  -moz-transform: translate3d(0px, 50px, 0px) scale(0.1, 0.1);
  -moz-transition: all 0.2s;
  -moz-border-radius: 5px;
  -o-transform: translate3d(0px, 50px, 0px) scale(0.1, 0.1);
  -o-transition: all 0.2s;
  -o-border-radius: 5px;
  -ms-transform: translate3d(0px, 50px, 0px) scale(0.1, 0.1);
  -ms-transition: all 0.2s;
  -ms-border-radius: 5px;
  transform: translate3d(0px, 50px, 0px) scale(0.1, 0.1);
  transition: all 0.2s;
  border-radius: 5px;
}

.turnjs-slider .thumbnail div {
  width: 100px;
  margin: 7px;
  height: 70px;
  background-color: white;
}

.turnjs-slider .ui-slider {
  position: relative;
  text-align: left;
}

.turnjs-slider .ui-slider-handle {
  border: 1px solid white;
  background-color: black;
  opacity: 0.2;
  display: block;
  -webkit-transition: opacity 0.2s;
  -moz-transition: opacity 0.2s;
  -ms-transition: opacity 0.2s;
  -o-transition: opacity 0.2s;
  transition: opacity 0.2s;
}

.yema {
  position: relative;
  top: -10px;
  left: 50%;
  margin-left: -30px;
  width: 60px;
  font-size: 14px;
  font-family: "微软雅黑";
  color: #000;
  text-align: center;
}

.flipbook .even {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(0.95, #fff),
    color-stop(1, #dadada)
  );
  background-image: -webkit-linear-gradient(to right, #fff 95%, #dadada 100%);
  background-image: -moz-linear-gradient(to right, #fff 95%, #dadada 100%);
  background-image: -ms-linear-gradient(to right, #fff 95%, #dadada 100%);
  background-image: -o-linear-gradient(to right, #fff 95%, #dadada 100%);
  background-image: linear-gradient(to right, #fff 95%, #dadada 100%);
}

.sj-book .odd {
  background: -webkit-gradient(
    linear,
    right top,
    left top,
    color-stop(0.95, #fff),
    color-stop(1, #cacaca)
  );
  background-image: -webkit-linear-gradient(to left, #fff 95%, #cacaca 100%);
  background-image: -moz-linear-gradient(to left, #fff 95%, #cacaca 100%);
  background-image: -ms-linear-gradient(to left, #fff 95%, #cacaca 100%);
  background-image: -o-linear-gradient(to left, #fff 95%, #cacaca 100%);
  background-image: linear-gradient(to left, #fff 95%, #cacaca 100%);
}

.zz_read1 {
  height: auto;
  padding-bottom: 20px;
}

.sc_banner img {
  width: 1920px;
  height: 450px;
  margin-left: calc(50vw - 960px);
}

.sc_banner {
  overflow: hidden;
}

.more_center {
  display: table;
  margin: 0 auto;
  position: relative;
  z-index: 1000;
  background: #f7f7f7;
  width: 160px;
}

.more_center .more {
  float: none;
  margin: 0 auto;
}

.more_centert {
  margin-top: 25px;
}

.ycwx_col {
  height: 342px;
}

.more_center_back {
  border-bottom: 1px solid #bbe6dd;
  width: 100%;
  float: left;
  margin-top: -15px;
}

.ycwx_col22 {
  height: 375px !important;
}

.or_list {
  background: #fff;
}

.fenlei span {
  margin-right: 40px !important;
}

.gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(0.95, rgba(0, 0, 0, 0)),
    color-stop(1, rgba(0, 0, 0, 0.2))
  );
  background-image: -webkit-linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 95%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: -moz-linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 95%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: -ms-linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 95%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: -o-linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 95%,
    rgba(0, 0, 0, 0.2) 100%
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 95%,
    rgba(0, 0, 0, 0.2) 100%
  );
}

.flipbook ::v-deep .page-wrapper {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}
.xxx {
  width: 80%;
  margin: 0 auto;
  background-position: center center;
  background-size: cover;
}
.cursorDefault {
  cursor: default !important;
}
</style>
